import { IntegrationsPage } from "@/components/admin/integrations/integrations-page.tsx";
import { m } from "@/paraglide/messages.js";
import { integrationsQueryOptions } from "@/services/integrations-service.ts";
import { mcpServersQueryOptions } from "@/services/mcp-servers-service.ts";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { integrationsTab } from "@/components/admin/integrations/integrations-tabs.ts";
import { pageTitle } from "@/utils/page-title.ts";

export const Route = createFileRoute(
	"/_authenticated/settings/org/integrations",
)({
	component: IntegrationsPage,
	// The page draws its own pane header and a category rail beside the content,
	// so it takes the whole settings pane instead of the form column.
	staticData: { settingsLayout: "full" },
	validateSearch: z.object({
		// .catch(): a hand-tampered ?tab=xyz degrades to the default view rather than the
		// route error boundary, matching `settings/org/rights.tsx`.
		tab: integrationsTab.optional().catch(undefined),
		category: z.string().optional().catch(undefined),
	}),
	loader: async ({ context: { queryClient } }) => {
		queryClient.prefetchQuery(integrationsQueryOptions());
		queryClient.prefetchQuery(mcpServersQueryOptions("org"));
	},
	head: () => ({
		meta: [{ title: pageTitle(m.integrations_page_title()) }],
	}),
});
